var LFCFG=JSON.parse((document.getElementById('lf-cfg-testimonial-tab-section-0')||{textContent:'{}'}).textContent);

(function () {
  'use strict';

  var VIDEO_COUNT   = LFCFG.v0;
  var WRITTEN_COUNT = LFCFG.v1;
  var VIDEO_MIN     = 5;
  var WRITTEN_MIN   = 4;

  var $playing  = null;   /* jQuery ref to currently playing .video-container */
  var isSliding = false;

  /* ── Build embed URL ── */
  function getEmbedInfo(url) {
    if (!url) return null;
    var embed = '', isMP4 = false;

    if (url.indexOf('youtube.com') > -1 || url.indexOf('youtu.be') > -1) {
      var id = '';
      try { id = new URL(url).searchParams.get('v'); } catch(e) {}
      if (!id) id = url.split('/').pop().split('?')[0];
      embed = 'https://www.youtube.com/embed/' + id +
              '?autoplay=1&rel=0&modestbranding=1&enablejsapi=1&playsinline=1';
    } else if (url.indexOf('vimeo.com') > -1) {
      var vid = url.split('/').pop().split('?')[0];
      embed = 'https://player.vimeo.com/video/' + vid + '?autoplay=1&api=1';
    } else if (/\.(mp4|mov|webm)$/i.test(url)) {
      embed = url; isMP4 = true;
    }

    return embed ? { url: embed, isMP4: isMP4 } : null;
  }

  /* ── Restore container to thumbnail state ── */
  function restoreContainer($c) {
    if (!$c || !$c.length) return;
    $c.find('iframe, video, .video-custom-controls').remove();
    $c.find('.video-thumb').show();
    $c.find('.play-icon').show();
  }

  /* ── Stop current playing video ── */
  function stopPlaying() {
    if (!$playing || !$playing.length) { $playing = null; return; }

    /* Pause iframe */
    var $if = $playing.find('iframe');
    if ($if.length) {
      var src = $if.attr('src') || '';
      try {
        if (src.indexOf('youtube') > -1) {
          $if[0].contentWindow.postMessage(
            JSON.stringify({ event:'command', func:'pauseVideo', args:[] }), '*');
        } else if (src.indexOf('vimeo') > -1) {
          $if[0].contentWindow.postMessage(
            JSON.stringify({ method:'pause' }), '*');
        }
      } catch(e) {}
    }

    /* Pause native video */
    var $v = $playing.find('video');
    if ($v.length) { try { $v[0].pause(); } catch(e) {} }

    restoreContainer($playing);
    $playing = null;
  }

  /* ── Play video in container ── */
  function playVideo($c) {
    /* Stop anything currently playing */
    stopPlaying();

    var videoUrl = $c.attr('data-video-url');
    var info = getEmbedInfo(videoUrl);
    if (!info) return;

    /* Hide play icon (thumbnail stays under iframe via z-index) */
    $c.find('.play-icon').hide();

    /* Controls */
    var $ctrl   = $('<div class="video-custom-controls"></div>');
    var $pauseB = $('<button>⏸</button>');
    var $muteB  = $('<button>🔊</button>');
    $ctrl.append($pauseB, $muteB);

    if (info.isMP4) {
      var $vid = $('<video autoplay playsinline loop></video>').attr('src', info.url);
      $c.append($vid, $ctrl);
      $playing = $c;
      $vid[0].play().catch(function(){});

      $pauseB.on('click', function(e) {
        e.stopPropagation();
        $vid[0].paused ? ($vid[0].play(), $pauseB.html('⏸')) : ($vid[0].pause(), $pauseB.html('▶'));
      });
      $muteB.on('click', function(e) {
        e.stopPropagation();
        $vid[0].muted = !$vid[0].muted;
        $muteB.html($vid[0].muted ? '🔇' : '🔊');
      });

    } else {
      var $iframe = $('<iframe allowfullscreen allow="autoplay; encrypted-media"></iframe>')
                      .attr('src', info.url);
      $c.append($iframe, $ctrl);
      $playing = $c;

      var muted = false, paused = false;

      function ytMsg(fn) {
        try {
          $iframe[0].contentWindow.postMessage(
            JSON.stringify({ event:'command', func:fn, args:[] }), '*');
        } catch(e) {}
      }
      function vimeoMsg(method) {
        try {
          $iframe[0].contentWindow.postMessage(
            JSON.stringify({ method:method }), '*');
        } catch(e) {}
      }

      $pauseB.on('click', function(e) {
        e.stopPropagation();
        paused = !paused;
        $pauseB.html(paused ? '▶' : '⏸');
        var isYT = videoUrl.indexOf('youtube') > -1 || videoUrl.indexOf('youtu.be') > -1;
        if (isYT) ytMsg(paused ? 'pauseVideo' : 'playVideo');
        else      vimeoMsg(paused ? 'pause' : 'play');
      });

      $muteB.on('click', function(e) {
        e.stopPropagation();
        muted = !muted;
        $muteB.html(muted ? '🔇' : '🔊');
        var isYT = videoUrl.indexOf('youtube') > -1 || videoUrl.indexOf('youtu.be') > -1;
        if (isYT) ytMsg(muted ? 'mute' : 'unMute');
        else {
          try {
            $iframe[0].contentWindow.postMessage(
              JSON.stringify({ method:'setVolume', value: muted ? 0 : 1 }), '*');
          } catch(e) {}
        }
      });
    }
  }

  /* ── Update neighbour classes ── */
  function updateClasses() {
    $('.video-slider .slick-slide').removeClass('is-prev is-next is-far-prev is-far-next');
    var $c = $('.video-slider .slick-slide.slick-center');
    $c.prev().addClass('is-prev');
    $c.next().addClass('is-next');
    $c.prev().prev().addClass('is-far-prev');
    $c.next().next().addClass('is-far-next');
  }

  /* ── Init video slider ── */
  function initVideoSlider() {
    var $s = $('.video-slider');
    if (!$s.length) return;
    if ($s.hasClass('slick-initialized')) { $s.off('beforeChange afterChange'); $s.slick('unslick'); }

    var ok = VIDEO_COUNT >= VIDEO_MIN;

    $s.slick({
      slidesToShow: 5, slidesToScroll: 1,
      centerMode: true, centerPadding: '0px',
      arrows: false, dots: ok, infinite: ok,
      autoplay: false, speed: 500,
      cssEase: 'cubic-bezier(0.25,0.46,0.45,0.94)',
      swipeToSlide: true, touchThreshold: 10, waitForAnimate: false,
      responsive: [
        { breakpoint: 1280, settings: { slidesToShow: 5, centerPadding: '0px' } },
        { breakpoint: 1024, settings: { slidesToShow: 3, centerPadding: '40px' } },
        /* Mobile: 1 full center card + dono side ki aadhi card peek */
        { breakpoint: 768,  settings: { slidesToShow: 3, centerMode: true, centerPadding: '80px' } },
        { breakpoint: 480,  settings: { slidesToShow: 3, centerMode: true, centerPadding: '0px' } }
      ]
    });

    updateClasses();

    $s.on('beforeChange', function() { isSliding = true; stopPlaying(); });
    $s.on('afterChange',  function() { isSliding = false; updateClasses(); });
  }

  /* ── Init written slider ── */
  function initWrittenSlider() {
    var $s = $('.written-slider');
    if (!$s.length) return;
    if ($s.hasClass('slick-initialized')) $s.slick('unslick');

    var ok = WRITTEN_COUNT >= WRITTEN_MIN;

    $s.slick({
      slidesToShow: 4, slidesToScroll: 1,
      arrows: false, dots: ok, infinite: ok,
      autoplay: ok, autoplaySpeed: 3500, speed: 500,
      cssEase: 'cubic-bezier(0.25,0.46,0.45,0.94)',
      swipeToSlide: true, touchThreshold: 10,
      responsive: [
        { breakpoint: 1024, settings: { slidesToShow: 4 } },
        { breakpoint: 768,  settings: { slidesToShow: 1, centerMode: true, centerPadding: '60px' } },
        { breakpoint: 480,  settings: { slidesToShow: 1.2, centerMode: false, infinite: false  } }
      ]
    });
  }

  /* ── Video click (delegated) ── */
  function bindVideoClick() {
    $(document).on('click', '.video-slider .video-container', function() {
      if (isSliding) return;
      var $c    = $(this);
      var $sl   = $c.closest('.slick-slide');

      if ($sl.hasClass('slick-center')) {
        /* Toggle: if same container already playing → stop, else play */
        if ($playing && $playing[0] === $c[0]) { stopPlaying(); }
        else { playVideo($c); }
      } else {
        /* Go to slide first, then play */
        stopPlaying();
        var idx = parseInt($sl.attr('data-slick-index'), 10);
        $('.video-slider').slick('slickGoTo', idx);
        $('.video-slider').one('afterChange', function() {
          requestAnimationFrame(function() { playVideo($c); });
        });
      }
    });
  }

  /* ── Tab switching ── */
  function bindTabs() {
    $(document).on('click', '.testimonial-tab-buttons .tab-btn', function() {
      var $b = $(this);
      if ($b.hasClass('active')) return;
      stopPlaying();
      $('.testimonial-tab-buttons .tab-btn').removeClass('active');
      $('.testimonial-tab-content').removeClass('active');
      $b.addClass('active');
      var tab = $b.data('tab');
      $('#' + tab + '-tab').addClass('active');
      if (tab === 'video') initVideoSlider(); else initWrittenSlider();
    });
  }

  /* ── Boot ── */
  $(document).ready(function() {
    initVideoSlider();
    initWrittenSlider();
    bindTabs();
    bindVideoClick();
  });

})();
